import { render } from "./PracticeQuestion.vue?vue&type=template&id=3748c3d4"
import script from "./PracticeQuestion.vue?vue&type=script&lang=ts"
export * from "./PracticeQuestion.vue?vue&type=script&lang=ts"
script.render = render
/* custom blocks */
import block0 from "./PracticeQuestion.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


export default script